import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "@/components/home/HomePage";
import { homeHead } from "@/components/home/home-head";
import { loadHome } from "@/components/home/home-loader";

export const Route = createFileRoute("/en/")({
  // Число стран для пина «за рубежом» и ссылки «Populyar» (29.10.2026). Сбой любой части — без неё.
  loader: () => loadHome("en"),
  head: () => homeHead("en"),
  component: function Page() {
    const data = Route.useLoaderData();
    return <HomePage lang="en" countries={data.countries} popular={data.popular} />;
  },
});
